<template>
    <modal id="addChallengeModal" v-model:show="$parent.addChallenge" class="modal fade" :show-close="true">
        <template #header>
            <h6 class="modal-title">Create Challenge</h6>
        </template>

        <!--User form data -->
        <el-form ref="formRef" :model="challengeForm" :rules="rules" label-position="left" label-width="auto"
            status-icon class="form-container">

            <el-form-item label="Title" prop="title">
                <el-input v-model="challengeForm.title" placeholder="Challenge Title" />
            </el-form-item>

            <el-form-item label="Description" prop="description">
                <el-input v-model="challengeForm.description" placeholder="Challenge Description" />
            </el-form-item>

            <el-form-item label="Venue" prop="venue">
                <el-input v-model="challengeForm.venue" placeholder="Challenge Venue" />
            </el-form-item>

            <el-form-item label="Duration" prop="duration">
                <el-input-number v-model="challengeForm.duration" :min="15" :max="240">
                    <template #suffix>
                        <span>Minutes</span>
                    </template>
                </el-input-number>
            </el-form-item>

            <el-form-item label="Compitition Type" prop="compitition_type">
                <el-radio-group v-model="challengeForm.compitition_type">
                    <el-radio v-for="option in compititionTypes" :key="option.value" :label="option.value">
                        {{ option.label }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>

            <UserMultiSelectDropdown v-if="challengeForm.compitition_type === 'Individuals'"
                @update-selected-users="updateSelectedUsers"></UserMultiSelectDropdown>

            <PlatoonDropdownV2 v-if="challengeForm.compitition_type === 'Platoon'" id="ddPlatoon" :allow-all="false"
                :selected="challengeForm.platoon_id" @selected-platoon-id="
                    (selectedValue) => (challengeForm.platoon_id = selectedValue)
                " />

            <SectionDropdownV2 v-if="challengeForm.compitition_type === 'Platoon'" id="ddSection"
                :selected="challengeForm.section_id" :allow-all="false" @selected-section-id="
                    (selectedValue) => (challengeForm.section_id = selectedValue)
                " />

            <CommunityDropdown v-if="false" id="ddCommunity" :selected="challengeForm.community_id" prop="community_id"
                @selected-community-id="(selectedValue) => (challengeForm.community_id = selectedValue)" />

            <el-form-item label="Start Time" prop="start_time">
                <el-date-picker v-model="challengeForm.start_time" type="datetime" aria-label="Select Start Time"
                    placeholder="Select Start Time" style="width: 100%" 
                    :disabled-date="disablePastDates"
                    :disabled-time="disabledTime" />
            </el-form-item>
            <el-form-item>
                <el-col :span="10">
                    <el-button @click="resetForm">Reset</el-button>
                </el-col>
                <el-col :span="12">
                    <div id="saveButton" style="float: right;">
                        <el-button type="primary" style="background-color: green;"
                            @click="saveAndStartChallenge(true)">Start</el-button>
                        <el-button :disabled="addingUser" type="primary"
                            @click="saveAndStartChallenge(false)">SAVE</el-button>
                    </div>
                </el-col>
            </el-form-item>
        </el-form>
    </modal>
</template>

<script>
import Modal from "@/shared/Modal.vue";
import PlatoonDropdownV2 from "../../components/PlatoonDropdownV2.vue";
import SectionDropdownV2 from "../../components/SectionDropdownV2.vue";
import CommunityDropdown from "../../components/CommunityList.vue";
import UserMultiSelectDropdown from "./UserMultiSelectDropdown.vue";

export default {
    name: 'CreateChallenge',
    components: {
        Modal,
        PlatoonDropdownV2,
        SectionDropdownV2,
        CommunityDropdown,
        UserMultiSelectDropdown,
    },
    data() {
        return {
            challengeForm: {
                title: '',
                description: '',
                name: '',
                platoon_id: -1,
                section_id: -1,
                community_id: -1,
                start_time: null,
                end_time: null,
                venue: '',
                duration: 0,
                compitition_type: 'Platoon',
            },
            rules: {
                title: [
                    { required: true, message: 'Title is required', trigger: 'blur' },
                    { min: 5, message: 'Title must be at least 5 characters', trigger: 'blur' }
                ],
                description: [
                    { required: false, message: 'Description is required', trigger: 'blur' },
                    { min: 5, message: 'Description must be at least 5 characters', trigger: 'blur' }
                ],
                // community_id: [
                //     { required: true, message: 'Community Group is required', trigger:'change'},
                //     { validator: validateCommunity, trigger: 'change' }   
                // ],
                name: [
                    { required: true, message: 'Name is required', trigger: 'blur' },
                    { minLength: 3, message: 'Name must be at least 3 characters', trigger: 'blur' }
                ],
                // platoon_id: [
                //     { required: true, message: 'Platoon is required', trigger: 'change' },
                //     { validator: validatePlatoon, trigger: 'change' }  
                // ],
                // section_id: [
                //     { required: true, message: 'Section is required', trigger: 'change' },
                //     { validator: validateSection, trigger: 'change' }   
                // ],
                // start_time: [
                //     { required: true, message: 'Start time is required', trigger: ['blur', 'change'] },
                // ],
                // end_time: [
                //     { required: true, message: 'End time is required', trigger: ['blur', 'change'] },
                // ],
                venue: [
                    { required: true, message: 'Venue is required', trigger: 'blur' },
                    { min: 5, message: 'Venue must be at least 5 characters', trigger: 'blur' }
                ],
                duration: [
                    { required: true, message: 'Duration is required', trigger: 'blur' },
                    // { min: 15, message: 'Duration must be at least 15', trigger: 'blur' }
                ],
            },
            addingUser: false,
            compititionTypes: [
                { label: 'Platoon', value: 'Platoon' },
                { label: 'Individuals', value: 'Individuals' }
            ],
            userIds: [],
        };
    },
    methods: {
        saveAndStartChallenge(startChallenge) {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    this.addChallenge(startChallenge);
                }
            });
        },
        resetForm() {
            this.challengeForm = {
                title: '',
                description: '',
                name: '',
                platoon_id: -1,
                section_id: -1,
                community_id: -1,
                start_time: null,
                end_time: null,
                venue: '',
                duration: 0,
                compitition_type: 'Platoon',
            };
            this.userIds = []; // Reset userIds as well
        },
        addChallenge(startChallenge) {
            this.$parent.addingChallenge = true;
            let userRequest = { ... this.challengeForm };
            userRequest.active = true;
            userRequest.userIds = this.userIds; // Ensure userIds are included in the request
            this.$store.dispatch("challenge/add", userRequest).then((res) => {
                console.log("Challenge created successfully:", res);
                this.$snackbar.add({
                    type: "success",
                    text: userRequest.title +" Challenge created successfully",
                });
                this.resetForm();
                this.$parent.addChallenge = false;
                this.$parent.fetchExistingChallenges();

                if (startChallenge) {
                    this.$parent.startChallenge(res.data);
                }
            });
        },
        closeModal() {
            this.resetForm();
        },
        updateSelectedUsers(users) {
            this.userIds = []
            for (let i = 0; i < users.length; i++) {
                this.userIds.push(users[i]);
            }
        },
        disablePastDates(time) {
            return time.getTime() < Date.now() - 8.64e7;
        },
        disabledTime(date) {
            const now = new Date();
            if (!date || date.toDateString() !== now.toDateString()) return {};
            const currentHour = now.getHours();
            const currentMinute = now.getMinutes();
            return {
                disabledHours: () =>
                    Array.from({ length: 24 }, (_, i) => i).filter(i => i < currentHour),
                disabledMinutes: (hour) => {
                    if (hour === currentHour) {
                        return Array.from({ length: 60 }, (_, i) => i).filter(i => i <= currentMinute);
                    }
                    return [];
                },
                disabledSeconds: () => [], // optionally disable past seconds
            };
        },
    }
};
</script>

<style scoped>
.form-container {
    max-width: 40rem;
    margin: auto;
    padding: 1rem;
    background-color: #283335;
    color: white;
    border-radius: 0.5rem;
}
</style>